/**
 * Servicio que se encarga del manejo de las peticiones sobre las 
 * acciones "Crear, Modificar y Eliminar" de los equipos.
 * JMM-2018-05-03
 */
import { Injectable } from '@angular/core';
//Enrutamientos
import { Http, Response, RequestOptions } from '@angular/http';
//Servicios
import { ConfigService } from '../../servicios/config/config.service';
//key 
import { KeyService } from '../../servicios/key.service'; 
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class EquiposService {

  public equipos : any[] = [];
  PATH = new ConfigService().obtenerPath();

  constructor(
    private http  : Http,
    private _key  : KeyService
  ) {}

  ngOnInit() {}

  /**
   * Obtener Componentes
   * JMM-2018-05-03
   */
  getEquipo()
  {
    let url = this.PATH + '/api/admin/equipos';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getEquipos()

  /**
   * Obtener un registro por id de un equipo para editar
   * JMM-2018-05-03
   */
  getRegEquipo(id:any)
  {
    let url = this.PATH + '/api/admin/equipos/'+id+'/edit'; 
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getRegMarca()

  /**
   * Enviar equipo
   * JMM-2018-05-03
   */
  setEquipo(equipo:any)
  {
    let url = this.PATH + '/api/admin/equipos';
    return this.http.post(url, equipo, {headers:this._key.head()}).map(resp => resp.json());
  }// .setEquipo(equipo:any)

  /**
   * Editar equipo
   * JMM-2018-05-03
   */
  editEquipo(equipo:any)
  {
    let url = this.PATH+'/api/admin/equipos/'+equipo.id;  
    var Headers =  new HttpHeaders();
    Headers.append('Content-Type','application/form-Data'); 
    return this.http.put(url,equipo, {headers:this._key.head()}).map( resp => resp.json()); 
  }// .editEquipo(equipo:any)


    /**
   * Editar equipo
   * JMM-2018-05-03
   */
  updateEquipo(equipo:any)
  {
    let url = this.PATH+'/api/admin/updateEquipo';   
    return this.http.post(url,equipo, {headers:this._key.head()}).map( resp => resp.json()); 
  }// .editEquipo(equipo:any)


  /**
   * Eliminar equipo
   * JMM-2018-05-03
   */
  destroyEquipo(id:any,equipoid:any)
  {
    let url = this.PATH + '/api/admin/equipos/'+id+'/'+equipoid+'/destroy';
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json());        
  }// .destroyEquipo(id:any)

 

  


  getFiltrosEquipos(inform){
    {
      let familiaid = inform.familiaid != '' ? inform.familiaid : null;
      let marcaid   = inform.marcaid   != '' ? inform.marcaid   : null;
      let equipoid  = inform.equipoid  != '' ? inform.equipoid  : null;
      let modelo    = inform.modelo    != '' ? inform.modelo    : null;
      let url;
      
      if (equipoid == null && modelo ==null && familiaid == null && marcaid == null) {
         url = this.PATH + '/api/admin/equipos';
        return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
        
      } else {
        url = this.PATH + '/api/admin/equiposfiltros';      
        return this.http.post(url, inform,{headers:this._key.head()}).map(resp => resp.json());
      }
    }// .getFiltrosIncidsencias(inform)
  }

  listEquipo()
  {
    let url = this.PATH+'/api/admin/listEquipo';   
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json()); 
  }// .listEquipo(equipoid:any)

  
  listEquipoSelect(equipoid) 
  {
    let url = this.PATH+'/api/admin/listEquipoSelect/'+equipoid;   
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json()); 
  }// .listEquipo(equipoid:any)

  storeComponenteEquipo(data)
  {
    let url = this.PATH+'/api/admin/storeComponenteEquipo';   
    return this.http.post(url,data ,{headers:this._key.head()}).map( resp => resp.json()); 
  }// .storeComponenteEquipo(equipoid:any)

  submitSubComponete(data)
  {
    let url = this.PATH+'/api/admin/submitSubComponete';   
    return this.http.post(url,data ,{headers:this._key.head()}).map( resp => resp.json()); 
  }// .submitSubComponete(equipoid:any)


  consultaSubComponente(componenteid,equipoid)
  {
    let url = this.PATH+'/api/admin/consultaSubComponente/'+componenteid+'/'+equipoid;   
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json()); 
  }// .listEquipo(equipoid:any)

  /**
   * Eliminar componente equipo
   */
  eliminarComponentes(id:any,equipoid:any)
  {
    let url = this.PATH + '/api/admin/eliminarComponentes/'+id+'/'+equipoid;
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json());        
  }// .eliminarComponentes(id:any)

  
}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/equipos/equipos.service.ts